const s = {
  name: "Trumpet",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,0H0v22h5v-1c0-2.6,0.7-4.9,1.9-6.5C8,12.9,9.5,12,11,12h1.7C11,13.5,10,15.6,10,18c0,4.4,3.6,8,8,8h10
			c4.4,0,8-3.6,8-8c0-2.4-1-4.5-2.7-6H38v6h2V4h-2v6h-9.2V8h-2v2h-3V8h-2v2h-3V8h-2v2H11c-1.5,0-3-0.9-4.1-2.5C5.7,5.9,5,3.6,5,1V0z
			 M16.8,18h2v-6h3v6h2v-6h3v6h2v-6c3,0.4,5.2,2.9,5.2,6c0,3.3-2.7,6-6,6H18c-3.3,0-6-2.7-6-6c0-2.9,2-5.3,4.7-5.9V18z M5.2,8.6
			c0.7,1,1.5,1.8,2.4,2.4c-0.9,0.6-1.7,1.4-2.4,2.4C4,15.1,3.2,17.4,3,20H2V2h1C3.2,4.6,4,6.9,5.2,8.6z"/>
		<path class="st0" d="M19,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C18.4,3.8,19,4.3,19,5z"/>
		<path class="st0" d="M22.8,6.3C23.4,6.3,24,5.7,24,5s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S22.1,6.3,22.8,6.3z"/>
		<path class="st0" d="M29,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C28.4,3.8,29,4.3,29,5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Trumpet
};
